import React, { useEffect, useState } from 'react'
import ClinicOverView from './clinicOverView'
import DoctorOverview from './DoctorOverView'
import ClinicTable from './clinicTable'
import "./clinicReport.css"
import strings from '../../Utils/strings'
import clinicService from '../../Services/clinicService'
import authService from '../../Services/authService'

function ClinicReport() {
    const [doctorList, setDoctorList]=useState([]);
    const [loading, setLoading] = useState(false);
    useEffect(()=>{
      if(authService.getIsDoctorLogin() === 'false'){
        getDoctors()
      }

    },[])
    const getDoctors = async () => {
        setLoading(true); 
        try {
          let response = await clinicService.getDoctorList();
          if (response.status === 'success') {
            const doctorData = response?.data?.doctors;
            if (doctorData) {
              setDoctorList(doctorData);
            }
          }
        } catch (error) {
          console.error("Error fetching doctors:", error);
        } finally {
          setLoading(false); 
        }
      };

    return (
            <React.Fragment>
                <div className="screen-name p-3 ml-3">{strings.sideMenu.report}</div>
                <div className='clinic-report-parent px-3'>
                    {authService.getIsDoctorLogin() === 'false' && <div className='clinic-overview-container mb-4 ml-3'>
                        <ClinicOverView doctorList={doctorList}/>
                    </div>}
                   
                    <div className='clinic-overview-container mb-4 ml-3'>
                        <DoctorOverview doctorList={doctorList}/>
                    </div>
                    <div className='clinic-overview-container mb-4 ml-3'>
                        <ClinicTable/>
                    </div>
                  
                </div>
            </React.Fragment >
    )
}

export default ClinicReport